import axios from "axios";
import HostService from "./host.service";
import AuthService from "./auth.service";


class NotificacionesService {

    static _urlBase64ToUint8Array(base64String) {
        const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding)
            .replace(/-/g, "+")
            .replace(/_/g, "/");

        const rawData = window.atob(base64);
        return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
    }

    // GET /notificaciones/public-key (público)
    static async getPublicKey() {
        const url = HostService.getHost() + "notificaciones/public-key";

        return axios
            .get(url) // sin AuthService.setToken()
            .then((res) => res.data?.data?.publicKey ?? null)
            .catch((e) => { console.log(e.message); throw e; });
    }

    /**
     * Registra el SW y devuelve la registration
     * (si ya está registrado, lo reutiliza)
     */
    static async registerServiceWorker() {
        if (!("serviceWorker" in navigator)) {
            throw new Error("Service Worker no soportado en este navegador");
        }
        return await navigator.serviceWorker.register("/sw.js");
    }

    /**
     * Devuelve una PushSubscription existente o crea una nueva.
     * Pide permiso al usuario si hace falta.
     */
    static async getOrCreateSubscription() {
        if (!("PushManager" in window)) {
            throw new Error("PushManager no soportado en este navegador");
        }

        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            throw new Error("Permiso de notificaciones denegado");
        }

        const registration = await NotificacionesService.registerServiceWorker();

        const existing = await registration.pushManager.getSubscription();
        if (existing) return existing;

        const publicKey = await NotificacionesService.getPublicKey();
        if (!publicKey) throw new Error("No se pudo obtener VAPID publicKey del backend");

        return await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: NotificacionesService._urlBase64ToUint8Array(publicKey)
        });
    }

    /**
     * POST /notificaciones/subscribe (auth)
     * Envía la subscription al backend para asociarla al usuario autenticado.
     */
    static async subscribe() {
        const subscription = await NotificacionesService.getOrCreateSubscription();

        return axios
            .post(
                HostService.getHost() + "notificaciones/subscribe",
                { subscription },
                AuthService.setToken()
            )
            .then((res) => res.data)
            .catch((e) => { console.log(e.message); throw e; });
    }
}

export default NotificacionesService;